var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('option',{attrs:{"id":_vm.optionId,"disabled":_vm.disabled},domProps:{"value":_vm.optionValue}},[_vm._v(" "+_vm._s(_vm.optionName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }